module.exports = __webpack_public_path__ + "static/media/f_hairstyle_straight_long_front_shadow.ad78dca9.png";